import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
const AddPaymentPlanLayer = () => {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [installments, setInstallments] = useState('');
    const [downpayment, setDownpayment] = useState('');
    const [loading, setLoading] = useState(false);
    const handleCancel = () => {
        navigate(-1); // Go back to the previous page in history
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        // Example: Prepare the payload and call an API
        const payload = {
            name,
            installments,
            downpayment,
        };

        api.post('/paymentplans/', payload).then(response => { toast.success("Payment Plan Added! "); }).catch(error=>{toast.error(error.response.data.message || 'An error occurred while adding the paymentplan.');});

        console.log('Payment Plan Data:', payload);
        setLoading(false);
        // Redirect or reset after successful submission
        navigate(-1); // Redirect to the previous page after submission
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
                <div className="row justify-content-center">
                    <div className="col-xxl-6 col-xl-8 col-lg-10">
                        <div className="card border">
                            <div className="card-body">
                                <h6 className="text-md text-primary-light mb-16">Add Payment Plan</h6>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="Name"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Nickname (choose a unique name for each plan to be able to differentiate them later) <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="name"
                                            placeholder="Enter the nickname"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="installments"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Installments (In Years)<span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control radius-8"
                                            id="installments"
                                            placeholder="Enter the number of installments years"
                                            value={installments}
                                            onChange={(e) => setInstallments(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-20">
                                        <label
                                            htmlFor="downpayment"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Downpayment % <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control radius-8"
                                            id="downpayment"
                                            placeholder="Enter the downpayment percentage"
                                            value={downpayment}
                                            onChange={(e) => setDownpayment(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <button
                                            type="button"
                                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                                            disabled={loading}
                                        >
                                            {loading ? <Spinner animation="border" size="sm" /> : 'Save'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddPaymentPlanLayer;
